import { Web3Auth } from "@web3auth/modal";
import { OpenloginAdapter } from "@web3auth/openlogin-adapter";
import React, { useEffect, useState } from "react";
import RPC from "../web3RPC"; // for using web3.js

import { CHAIN_NAMESPACES } from "@web3auth/base";

// init only for specific clients
export const VALID_WEB3_HOST = [
  "tech.pensil.in",
  "tech.pensil.so",
  "tech.pensil.com",
  "berryfy-test.pensil.so",
  "berryfy.pensil.in",
  "hub.berryfy.io",
  "berryfy-test.pensil.com",
  "fox.pensil.in",
  "fox.berryfy.io",
  "core.pensil.in",
  "fans.coremusic.xyz",
  "freiwild.pensil.in",
  "freiwild.coremusic.xyz",
];

const clientId = process.env.REACT_APP_WEB3_CLIENT_ID; // get from https://dashboard.web3auth.io

// interface Web3ContextValue {
//   web3auth: null | any;
//   setWeb3auth: Function;
//   provider: any;
//   setProvider: Function;
//   web3Logout: Function;
// }

export const Web3Context = React.createContext(null);

export const Web3Provider = (props) => {
  const [web3auth, setWeb3auth] = useState(null);
  const [provider, setProvider] = useState(null);

  // initialize the plugin
  useEffect(() => {
    const init = async () => {
      try {
        const web3auth = new Web3Auth({
          clientId,
          chainConfig: {
            chainNamespace: CHAIN_NAMESPACES.EIP155,
            chainId: "0x13881",
            rpcTarget: "https://rpc.ankr.com/polygon_mumbai",
          },
          uiConfig: {
            theme: "dark",
            // loginMethodsOrder: ["facebook", "google", "twitter", "apple"],
            loginMethodsOrder: [""],
            defaultLanguage: "en",
            appLogo: "https://web3auth.io/images/w3a-L-Favicon-1.svg", // Your App Logo Here
          },
          web3AuthNetwork: "mainnet",
        });

        const openloginAdapter = new OpenloginAdapter({
          loginSettings: {
            curve: "ed25519", // allowed values "secp256k1" (default) or "ed25519"
            mfaLevel: "none",
          },
          adapterSettings: {
            clientId,
            uxMode: "popup",
            whiteLabel: {
              name: "Web3Auth Chrome Extension",
              logoLight: "https://web3auth.io/images/w3a-L-Favicon-1.svg",
              logoDark: "https://web3auth.io/images/w3a-D-Favicon-1.svg",
              defaultLanguage: "en",
              dark: true, // whether to enable dark mode. defaultValue: false
            },
          },
        });
        web3auth.configureAdapter(openloginAdapter);

        setWeb3auth(web3auth);

        await web3auth.initModal();
        if (web3auth.provider) {
          setProvider(web3auth.provider);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (VALID_WEB3_HOST.includes(window.location.hostname)) {
      console.log("Initializing web3");
      init();
    }

    // if (window.innerWidth > 400) setIsFullPage(true)
  }, []);

  const getWeb3Accounts = async () => {
    if (!provider) {
      return;
    }
    const rpc = new RPC(provider);
    return await rpc.getAccounts();
  };

  const web3Logout = async () => {
    if (!web3auth) {
      // console.log("web3auth not initialized yet")
      return;
    }
    try {
      await web3auth.logout();
    } catch (error) {}
    setProvider(null);
  };

  return (
    <Web3Context.Provider
      value={{
        web3auth,
        setWeb3auth,
        provider,
        setProvider,
        web3Logout,
        getWeb3Accounts,
      }}>
      {props.children}
    </Web3Context.Provider>
  );
};

export const withWeb3 = (Component) => (props) =>
  (
    <Web3Context.Consumer>
      {(web3Props) => <Component {...web3Props} {...props} />}
    </Web3Context.Consumer>
  );
